<template>
  <div class="stat-tile">
    <span class="stat-tile__accent" :style="{ background: accent }"></span>
    <div class="stat-tile__icon" :style="{ background: accent }">
      <v-icon small color="white">{{ icon }}</v-icon>
    </div>
    <div class="stat-tile__body">
      <div class="stat-tile__value">{{ value }}</div>
      <div class="stat-tile__label">{{ title }}</div>
      <div v-if="hint" class="stat-tile__hint">{{ hint }}</div>
    </div>
  </div>
</template>

<script>
/**
 * Shared summary tile: coloured accent rail + icon chip, bold value over a small
 * uppercase label. Registered globally as `<base-stat-tile>` (see plugins/base.js),
 * so the Trips, Asset Info and Reports dashboards stay visually identical.
 */
export default {
  name: "StatTile",
  props: {
    title: { type: String, default: "" },
    value: { type: [String, Number], default: "" },
    icon: { type: String, default: "mdi-chart-box-outline" },
    // Any CSS colour: it tints both the icon chip and the accent rail.
    accent: { type: String, default: "#2962ff" },
    // Optional caption, e.g. the period the figure covers.
    hint: { type: String, default: "" },
  },
};
</script>

<style scoped>
.stat-tile {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  min-height: 62px;
  padding: 10px 14px 10px 16px;
  border-radius: 14px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(16, 24, 40, 0.06);
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06),
    0 12px 24px -20px rgba(16, 24, 40, 0.5);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}
.stat-tile:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(16, 24, 40, 0.08),
    0 18px 32px -22px rgba(16, 24, 40, 0.55);
}
.stat-tile__accent {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
}
.stat-tile__icon {
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stat-tile__body {
  margin-left: 12px;
  min-width: 0;
}
.stat-tile__value {
  font-size: 1.15rem;
  font-weight: 600;
  line-height: 1.15;
  color: #101828;
  white-space: nowrap;
}
.stat-tile__label {
  margin-top: 2px;
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #98a2b3;
}
.stat-tile__hint {
  margin-top: 2px;
  font-size: 0.68rem;
  color: #b0b8c4;
}
</style>
